
/* injects from baggage-loader */

'use strict';

export default class HomeController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {
		
	}

}



// WEBPACK FOOTER //
// ./src/app/pages/home/home.controller.js